const mapColorType = {
  secondary: "secondary",
  primary: "primary",
  quaternary: "default",
  tertiary: "info",
  invert: "inherit"
}, mapSizeType = {
  xs: "small",
  md: "mediumNew",
  lg: "medium",
  xl: "large"
}, mapSizes = {
  small: "18px",
  medium: "24px",
  mediumNew: "24px",
  large: "36px"
}, mapSizesIconContainer = {
  small: "24px",
  medium: "42px",
  mediumNew: "40px",
  large: "60px"
};
export {
  mapColorType,
  mapSizeType,
  mapSizes,
  mapSizesIconContainer
};
//# sourceMappingURL=constants.js.map
